import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SeoLink } from '@models/seo/seo-link';

@Component({
  selector: 'directory-list-letter-page',
  templateUrl: './list-letter-page.component.html',
  styleUrls: ['./list-letter-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListLetterPageComponent {
  @Input() jobs: boolean;
  @Input() companies: boolean;
  @Input() list: SeoLink[];
  @Input() page: string;
  @Input() letter: string;

  trackByTitle(_: any, link: SeoLink): string {
    return link.title;
  }
}
